import React from 'react'
import tankImage from "../../../images/products/E.png"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/home/p-5.jpg'

function LenoBag() {

  const values = [
  {
    number: 1,
    text: "Breathable design – Mesh structure allows air circulation to keep produce fresh.",
  },
  {
    number: 2,
    text: "Lightweight – Easy to carry, transport, and store without adding bulk.",
  },
  {
    number: 3,
    text: "High strength – Woven from durable polypropylene to handle heavy loads.",
  },
  {
    number: 4,
    text: "Reusable – Can be used multiple times, making it cost-effective and eco-friendly.",
  },
  {
    number: 5,
    text: "UV stabilized – Resists sunlight exposure, ideal for outdoor use and storage.",
  },
  {
    number: 6,
    text: "Drawstring/tie closure – Secures the contents easily during transport.",
  },
  {
    number: 7,
    text: "Custom sizes and colors – Available in different capacities and vibrant color options.",
  },
  {
    number: 8,
    text: "Ideal for fresh produce – Perfect for onions, potatoes, garlic, ginger, and more.",
  },
];


  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'Leno Bag'} pagesub={'Products'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
      <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">Breathable Bags. Fresh Solutions.</h2>
  <p style={{ textAlign: "justify" }}>
    Leno bags are lightweight, breathable mesh bags widely used for packing and transporting fresh produce. Ideal for vegetables, fruits, and firewood, these bags allow air circulation, keeping contents fresh and minimizing spoilage during storage and transit.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we manufacture high-quality leno bags using strong, flexible polypropylene material. These bags are UV-stabilized, reusable, and equipped with drawstring or tie closures for secure handling. Their ventilated design prevents moisture buildup while maintaining product visibility.
  </p>
  <p style={{ textAlign: "justify" }}>
    Available in various sizes, colors, and capacities, our leno bags are perfect for packing onions, potatoes, garlic, ginger, and other farm produce. Lightweight yet durable, they offer a cost-effective, eco-friendly solution for both farmers and retailers.
  </p>
</div>

      </div>
    </section>
 {/* <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">Leno Bag</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
              Leno Bag available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
               Leno Bag Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>1850</td>
              <td>2070</td>
              <td>2650</td>
              <td>3050</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>1550</td>
              <td>1870</td>
              <td>1940</td>
              <td>2120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default LenoBag